import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { CustomersArray } from '../../types/Customer';
import { ApiError } from '../../types/Error';
import { getCustomers } from '../Customers';

export const useGetCustomers = (): UseQueryResult<CustomersArray, ApiError> => {
    return useQuery({
        queryKey: ['customers'],
        queryFn: () => getCustomers(),
        retry: false
    });
};
